.pending,
.failed {
  margin: 0;
  padding: 14px 16px;
  border: var(--outline);
  border-radius: var(--radius-card);
  font-size: 15px;
  line-height: 1.5;
  color: var(--ink);
}

.pending {
  background: var(--surface);
}

.failed {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: var(--error-soft);
}

.text {
  margin: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.button {
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 700;
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
